<template>
  <DataNotFound/>
</template>

<script>
	import DataNotFound from '@/components/DataNotFound';

  export default {
		name: 'Membership',
		components: {
			DataNotFound,
		},
  }
</script>